var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"title":_vm.title}}),_c('main',{staticClass:"content"},[_c('router-view')],1),_c('Footer'),_c('loading'),_c('PageTopButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }